module.exports = __webpack_public_path__ + "static/media/logo_meta.5b978a0e.svg";